<mat-toolbar>
  <mat-toolbar-row class="mat-toolbar-row mat-toolbar-variant">
    <div class="menu-button-ajustado">
      <button
        mat-icon-button
        (click)="toggleDrawer()"
        class="example-icon"
        aria-label="Example icon-button with menu icon"
        style="background-color: var(--primary-color); margin-left: -22px"
      >
        <mat-icon style="color: white;">menu</mat-icon>
      </button>
    </div>
    <div
      class="flex justify-center items-center"
      style="background-color: var(--primary-color); height: 100%; gap: 80px"
    >

      <img src="assets/images/dicea/Logo_horizontal_Dicea_02.png" alt="Logo dicea" width="110" height="110" />


      <app-breadcrumb
        style="
          background-color: #f4f4f4;
          height: 100%;
          border-bottom: 1px solid #4d4d4d4d;
        "
      ></app-breadcrumb>
    </div>
    <span class="example-spacer"></span>
    <!-- <app-buscar-general></app-buscar-general>
    <app-btn-notificaciones></app-btn-notificaciones> -->
    <nav-search-perfil-logo></nav-search-perfil-logo>
  </mat-toolbar-row>
</mat-toolbar>

<mat-drawer-container autosize="false" autoFocus="false">
  <mat-drawer #drawer mode="over" position="start" autoFocus="false">
    <div class="space-mat-drawer"></div>
    <app-menu-principal
      (toggleDrawerEvent)="toggleDrawer()"
    ></app-menu-principal>
  </mat-drawer>
  <mat-drawer-content>
    <!-- Contenido principal -->
    <div class="container-fluid p-2 my-2">
      <router-outlet></router-outlet>
    </div>
  </mat-drawer-content>
</mat-drawer-container>
